package app.nestbridge.domain.identity.api

import app.nestbridge.app.di.ClientApiConfig
import app.nestbridge.domain.identity.api.model.ProfessionalProfileDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class RemoteProfessionalProfileApiClient(
    private val httpClient: HttpClient,
    private val config: ClientApiConfig,
) : ProfessionalProfileApiClient {

    private val baseUrl get() = "${config.identityServiceUrl}/user/me/professional-profile"

    override suspend fun fetchCurrent(): ProfessionalProfileDto? {
        val response: HttpResponse = httpClient.get(baseUrl)
        return when (response.status) {
            HttpStatusCode.OK -> response.body()
            HttpStatusCode.NotFound -> null
            else -> error("Unexpected response fetching professional profile: ${response.status}")
        }
    }

    override suspend fun save(profile: ProfessionalProfileDto): ProfessionalProfileDto {
        val response = if (profile.id.isBlank()) {
            httpClient.post(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(profile)
            }
        } else {
            httpClient.put(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(profile)
            }
        }
        return response.body()
    }
}
